import { SelectStatementResult } from 'src/app/models/select-statement-result.model';
import { BaseSelectStatementId } from 'src/app/enums/base-select-statement-id.enum';
import { TableDataOperator } from './../operators/table-data.operator';
import { Injectable } from '@angular/core';
import { SelectStatementOptions } from '../models/select-statement-options.model';
import { RouteData } from './route-data.model';
import { BaseService } from '../services/base.service';
import { LoadingIndicationService } from '../services/loading-indication.service';

@Injectable({
	providedIn: 'root'
})
export class RoutesDataService {

	private _routesTableDataOperator: TableDataOperator<RouteData> = new TableDataOperator<RouteData>(
		new SelectStatementOptions(
			{
				baseSelectStatementId: BaseSelectStatementId.DEV_GetRoutes,
			}
		),
		RouteData
	);


	public getRoutesData(): Promise<RouteData[]> {
		if (!this._baseService.checkSession()) {
			let data: RouteData[] = [];

			return Promise.resolve(data);
		}
		else {
			return new Promise<RouteData[]>(
				(resolve, reject) => {
					this._routesTableDataOperator.getObservable(
						{
							name: 'Load Dynamic Routes',
							showLoadingIndicator: false,
							responseLoggingEnabled: false,
						}
					).then(
						(promiseResponse) => {
							promiseResponse.subscribe(
								{
									next: (selectStatementResult: SelectStatementResult<RouteData>) => {
										resolve(selectStatementResult.data);
									},
									error: (error) => {

										if (error.status === 401) {
											console.warn("getRoutesData -> ", error);

											resolve([]);
										}

										reject(error);
									}
								}
							)
						}
					);
				}
			);
		}
	}

	constructor(
		private _baseService: BaseService,
		// private _loadingIndicationService: LoadingIndicationService,
	) { }
}
